import script from "./MmTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MmTable.vue?vue&type=script&setup=true&lang=js"

import "./MmTable.vue?vue&type=style&index=0&id=d8ae9686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ae9686"]])

export default __exports__